import { render, staticRenderFns } from "./PwdModal.vue?vue&type=template&id=084d89b4&scoped=true&"
import script from "./PwdModal.vue?vue&type=script&lang=js&"
export * from "./PwdModal.vue?vue&type=script&lang=js&"
import style0 from "./PwdModal.vue?vue&type=style&index=0&id=084d89b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084d89b4",
  null
  
)

export default component.exports